interface MeddiGridItemProps {
	item: any;
	template: any;
}

export default function MeddiGridItem(props: MeddiGridItemProps) {
	const { item, template } = props;

	return template(item);
}
